import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../../shared/services';

@Component({
  selector: 'app-help-text',
  templateUrl: './help-text.component.html',
  styleUrls: ['./help-text.component.scss'],
  standalone: false
})
export class HelpTextComponent implements OnInit {

  helpTitle!: string;
  helpText!: string;

  helpText_hu = `
<h3>Publikus fel&uuml;let</h3>

<p>A rendszer publikus fel&uuml;let&eacute;n b&aacute;rki megtekintheti a MEKH &aacute;ltal k&ouml;zz&eacute;tett kimutat&aacute;sokat.</p>

<h3>Funció gombok</h3>

<p><span class="help-text-size"><img src="assets/images/reports_button_hu.png" height="36px" alt="Riportok litásra navigálás" class="help-funkcio-gomb" /> Kattintson erre a gombra a főoldalra történő visszanavigáláshoz. </span></p>
<p><span class="help-text-size"><img src="assets/images/help_button_hu.png"  height="36px"  alt="Súgó" class="help-funkcio-gomb" /> Kattintson erre a gombra a Súgó felület megnyitásához. </span></p>
<p><span class="help-text-size">A <img src="assets/images/lang_button_hu.png"  height="36px"  alt="Nyelv kiválasztása az oldalon" class="help-funkcio-gomb" /> gombbal váltható a felület nyelve magyar és angol között.</span></p>

<p>&nbsp;</p>

<h3>Főoldal</h3>

<p><span class="font-size:16px;">A főoldalon l&eacute;vő list&aacute;ban tal&aacute;lhat&oacute;k a Hivatal által közzétett kimutat&aacute;sok.<br />Egy kimutatás megnyitásához kattintson annak nevére.</span></p>
<p><span class="font-size:16px;">A list&aacute;ban az egyes kimutat&aacute;sokr&oacute;l az al&aacute;bbi információk érhetók el:</span></p>

<ul>
  <li><span class="help-text-size">Kimutat&aacute;s megnevez&eacute;se</span></li>
  <li><span class="help-text-size">A kimutat&aacute;sr&oacute;l rövid le&iacute;r&aacute;sa</span></li>
  <li><span class="help-text-size">Az utols&oacute; friss&iacute;t&eacute;s d&aacute;tuma</span></li>
</ul>

<p><img src="assets/images/so_public_landing_hu.png" height="455px" width="1039px" alt="Riportok listája" class="h0-image-size" /></p>
<p>&nbsp;</p>
<h3>Riportok megjelen&iacute;t&eacute;se</h3>

<p><img src="assets/images/so_report_example_hu.png" height="461px" width="1038px" alt="Riport példa bemutatása" class="h4-image-size" /></p>

<p>
  <span class="help-text-size">A riport címe és leírása a riportoldal felső részében láthatóak. A tábla jobb felső sarkában találhatóak a Mezőválasztó és az „Exportálás Excel táblázatba” gombok.</span>
</p>

<p>&nbsp;</p>

<h3>&Eacute;vre szűr&eacute;s</h3>

<p><span class="help-text-size">Az év szerinti szűréshez az Év szűrő használható, mely a tábla bal felső sarkában található. Az Év szűrő segítségével az év a Mezőválasztó nélkül állítható be.</span></p>

<p><img src="assets/images/year_select_hu.png" height="303px" width="261px"  alt="Az év vagy évek kiválasztása" class="h5-image-size" /></p>

<p>&nbsp;</p>

<h3>Exportálás Excel táblába</h3>

<p><img src="assets/images/h6_excel-export-gomb.png" height="36px" width="36px" alt="Excel export gomb" class="help-gomb-size" /> <span class="help-text-size"> Az „Exportálás Excel táblázatba” gombra kattintva a rendszer a jelentés aktuális megjelenítése és a megadott szűrési feltételek alapján egy Excel-formátumú (.xlsx) táblázatot állít össze és tölt le.</span></p>

<p>&nbsp;</p>

<h3>Mezőv&aacute;laszt&oacute;</h3>

<p>
  <span class="help-text-size">Minden jelentésnek van egy alapértelmezett elrendezése, amely megváltoztatható. A szűrési és elrendezési beállítások megtekintéséhez vagy módosításához kattintson a tábla bal felső sarkában található </span>
  <img src="assets/images/h7_mezo-valaszto-gomb.png" height="36px" width="36px"  alt="Mezőválasztó gomb" class="help-gomb-size" />
  <span class="help-text-size">gombra.</span>
</p>

<p><span class="help-text-size">A mezőv&aacute;laszt&oacute; ablakban a felhaszn&aacute;l&oacute; be&aacute;ll&iacute;thatja az egyes riportok sz&aacute;m&aacute;ra megfelelő n&eacute;zet&eacute;t &eacute;s szűr&eacute;si felt&eacute;teleit. Az egyes mezőket drag and drop technik&aacute;val lehet mozgatni az oldalon. Az oldal frissítése visszaállítja a riportot az alapértelmezett nézetre.</span></p>

<p><img src="assets/images/field_select_hu.png" height="417px" alt="Mezőválasztó felület" class="h8-image-size" /></p>

<h3><span class="help-text-size">A mezőv&aacute;laszt&oacute; fel&eacute;p&iacute;t&eacute;se:</span></h3>

<ul>
  <li><span class="help-text-size">Összes mező: Ebben a felsorolásban jelenik meg az adott riporthoz tartozó összes lehetséges érték és dimenzió mező. Az itt található mezők megfelelő helyre illesztésével alakítható ki az egyéni nézet, az alábbi korlátozásokkal:
  </span>

    <ul>
      <li>
        <span class="help-text-size">Érték mezők: Ezek a mezők numerikus értékeket tartalmaznak, az adott jelentéshez tartozó mértékegységek szerint. Csak az Adatmező-területre helyezhetőek el. Az értékmezőket a 
        <img src="assets/images/summa.png" height="36px" width="36px" alt="summa" class="help-gomb-size"/>
        ikon jelöli.</span>
      </li>
      <li>
        <span class="help-text-size">Dimenzió mezők: Ezek a mezők tartalmazzák az egyes tengelyekhez tartozó feliratokat. Kerülhetnek a sormező, az oszlopmező vagy a szűrőmező helyekre.<br />
        Amennyiben egy sor- vagy oszlopmező hierarchiát tartalmaz, azon mező alá más mező már nem helyezhető. A hierarchiával rendelkező mezőket a 
        <img src="assets/images/hierachi.png" height="36px" width="36px" alt="hierarchi" class="help-gomb-size"/>
        ikon jelöli.</span>
    </ul>
  </li>
  <li><span class="help-text-size">Szűrés beállításához a mezők megnevezéseinek végén található <img src="assets/images/szuro.png" height="36px" width="36px" alt="szuro" class="help-gomb-size" />ikonra kell kattintani. Évre szűrés a mezőválasztóban nem lehetséges.</span></li>
</ul>`;

  helpText_en = `
<h3>Public pages</h3>

<p>HEA publishes reports regularly in the Dissemination Database.</p>
<h3>Function buttons</h3>
<p><img src="assets/images/reports_button_en.png" height="36px" alt="Riportok litásra navigálás" class="help-funkcio-gomb" /><span class="help-text-size">&nbsp;Click this button to navigate back to the Main page.</span></p>
<p><img src="assets/images/help_button_en.png"  height="36px"  alt="Súgó" class="help-funkcio-gomb" /><span class="help-text-size">&nbsp;Click this button to navigate to the Help page.</span></p>
<p><img src="assets/images/lang_button_en.png"  height="36px"  alt="Nyelv kiválasztása az oldalon" class="help-funkcio-gomb" /><span class="help-text-size">&nbsp;Click here to switch the language between Hungarian and English.</span></p>

<p>&nbsp;</p>

<h3>Main page</h3>

<p><span class="font-size:16px;">On this page, the list of reports published by HEA is displayed. To open a report, click on its name.</span></p>
<p><span class="font-size:16px;">The following information is shown for each report</span></p>

<ul>
  <li><span class="help-text-size">Report title</span></li>
  <li><span class="help-text-size">Report description</span></li>
  <li><span class="help-text-size">Date of last update</span></li>
</ul>

<p><img src="assets/images/so_public_landing_en.png" height="461px" width="1039px" alt="Reports list" class="h0-image-size" /></p>

<p>&nbsp;</p>

<h3>Viewing reports</h3>

<p><img src="assets/images/so_report_example_en.png" height="461px" width="1038px" alt="Report exaample" class="h4-image-size" /></p>

<p>
  <span class="help-text-size">At the top of each report page you will find the report title and its description. In the top right corner of the table you will find buttons for the Field Selector and for Exporting the table to an Excel file.</span>
</p>

<p>&nbsp;</p>

<h3>Filtering Years</h3>

<p><span class="help-text-size">To filter by year, use the Year Filter located at the top left corner of each table. This allows you to set the year without using the Field Selector.</span></p>

<p><img src="assets/images/year_select_en.png" height="303px" width="261px"  alt="Filter of the years" class="h5-image-size" /></p>

<p>&nbsp;</p>

<h3>Exporting to Excel</h3>

<p><img src="assets/images/h6_excel-export-gomb.png" height="36px" width="36px" alt="Excel export gomb" class="help-gomb-size" /> <span class="help-text-size">&nbsp;By clicking the "Export to Excel" button, a file will be generated and downloaded based on the current view and filter conditions of the report. The file will be in .xlsx format (Microsoft Excel table).</span></p>

<p>&nbsp;</p>

<h3>Field selector</h3>

<p>
<span class="help-text-size">Each report has a default layout that can be modified by the user. To view or change the filter and layout settings, click the </span>
<img src="assets/images/h7_mezo-valaszto-gomb.png" height="36px" width="36px"  alt="Field selector button" class="help-gomb-size" />
<span class="help-text-size">button in the upper left corner of the table.</span>
</p>

<p><span class="help-text-size">In the Field Selector window, users can configure the layout and filter criteria for each report. Fields can be rearranged using drag and drop. By refreshing the page the layout and filter settings will reset to the default configuration.</span></p>

<p><img src="assets/images/field_select_en.png" height="417px" alt="Mezőválasztó felület" class="h8-image-size" /></p>

<h3><span class="help-text-size">Structure of the Field selector:</span></h3>

<ul>
  <li><span class="help-text-size">All fields: This list shows all available Value and Dimension fields for a given report. By moving a field to a Field Area, you can create a custom view, with the following restrictions:</span>

    <ul>
      <li><span class="help-text-size">Value (measurable) fields: These contain numerical values based on the units of measure specific to each report. Only these fields can be moved into the Data field area. These fields are indicated with the <img src="assets/images/summa.png" height="36px" width="36px" alt="summa" class="help-gomb-size"/>&nbsp;sum icon.</span></li>
      <li>
        <span class="help-text-size">Dimension fields: These provide labels for the axes. A Dimension field can be placed in the Row, Column, or Filter areas.<br />
        When a Dimension field that contains hierarchy is placed into the Row or Column area, no other field can be placed beneath it. Fields with hierarchies are indicated with the following symbol:</span>
        <img src="assets/images/hierachi.png" height="36px" width="36px" alt="hierarchi" class="help-gomb-size"/>
      </li>
    </ul>
  </li>
  <li><span class="help-text-size">To filter a field, click on the <img src="assets/images/szuro.png" height="36px" width="36px" alt="filter" class="help-gomb-size" />icon at the end of the field name. Please note: Filtering by year is not possible in the field selector.</span></li>
</ul>`;

  _language: string;

  constructor(private languageService: LanguageService) {
    this._language = this.languageService.language;
  }

  ngOnInit(): void {
    this.helpTitle = (this._language === 'en') ? 'Help' : 'Súgó';
    this.helpText = (this._language === 'en') ? this.helpText_en : this.helpText_hu;
  }

}
